import { render, staticRenderFns } from "./ClientsAccountTable.vue?vue&type=template&id=24adb114&"
import script from "./ClientsAccountTable.vue?vue&type=script&lang=js&"
export * from "./ClientsAccountTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientsAccountTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports